<template>
  <div class="avatar" v-bind="getAttributes(status)">
    <img
        class="img-avatar"
        loading="lazy"
        :src="image && !isImageError ? image : defaultImage"
        :alt="alt"
        @error="handleImageError"
    />
    <span :class="`${type}-status ${statusClass}`"/>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    type: {
      type: String,
      default: "avatar"
    },
    alt: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: "offline"
    },
    statusClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isImageError: false,
      defaultImage: '/images/user.png'
    };
  },
  methods: {
    getAttributes(status) {
      if (status !== 'online') {
        return {
          'data-toggle': 'tooltip',
          'data-placement': 'left',
          'title': this.alt
        };
      }

      return {};
    },
    handleImageError() {
      this.isImageError = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 36px;
  border-radius: 50%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>